module.exports = __webpack_public_path__ + "static/img/GQ.26c82fb3.svg";